import videoLoader from '../../../../../../src/js/modules/videoLoader';

window.addEventListener('load', () => {
    videoLoader.init();
}, false);
